<h1 mat-dialog-title>Confirmare stergere</h1>
<div mat-dialog-content>
    <p>Esti sigur ca vrei sa stergi aceasta inregistrare?</p>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Nu</button>
    <button mat-button (click)="onClickYes()" cdkFocusInitial>Da</button>
</div>